import React from 'react';
import { Badge } from 'reactstrap';

export const StatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const getStatusConfig = () => {
    switch (status?.toLowerCase()) {
      case 'posted':
        return {
          color: 'success',
          icon: 'bx-check-circle',
          label: 'Posted',
        };
      case 'draft':
        return {
          color: 'warning',
          icon: 'bx-edit',
          label: 'Draft',
        };
      case 'voided':
        return {
          color: 'danger',
          icon: 'bx-x-circle',
          label: 'Voided',
        };
      default:
        return {
          color: 'secondary',
          icon: 'bx-circle',
          label: status,
        };
    }
  };

  const config = getStatusConfig();

  return (
    <Badge color={config.color} pill className="d-inline-flex align-items-center gap-1 px-3 py-2">
      <i className={`bx ${config.icon} fs-6`}></i>
      <span className="fw-semibold">{config.label}</span>
    </Badge>
  );
};
